import {
  Box,
  Button,
  Divider,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { CanadaFlagIcon, VellisLogoIcon } from "../../customIcons";
import ICONS from "../../../constants/socialMedia";
import { useForm } from "@formspree/react";
import { solutionsLinks } from "../../../constants/solutionsLinks"; // Import the solutionsLinks array

const Footer = () => {
  const [state, handleSubmit] = useForm("xvojvpry");

  return (
    <Stack>
      <Stack mb={14} maxW="1280px" mx="auto" w="100%" px={4}>
        <form onSubmit={handleSubmit}>
          <Stack bg="#113F42" p={{ base: 5, md: 10 }} borderRadius="16px">
            <HStack
              gap={5}
              justifyContent="space-between"
              flexDir={{ base: "column", md: "row" }}
            >
              <VStack alignItems="flex-start" className="regular-text" gap={2}>
                <Text fontSize="16px" fontWeight={600} color="white">
                  Follow our latest news
                </Text>
                <Text color="rgba(255, 255, 255, 0.80)">
                  Subscribe to stay updated on the latest developments and
                  special offers.
                </Text>
              </VStack>
              <VStack w={{ base: "100%", md: "500px", lg: "590px" }}>
                <InputGroup w={{ base: "100%", md: "500px", lg: "590px" }}>
                  <InputRightElement width="119px" h="100%">
                    <Button
                      type="submit"
                      mr="3px"
                      w="100%"
                      bg="#fff"
                      h="42px"
                      borderRadius="9999px"
                      color="#000"
                      fontSize="16px"
                      className="medium-text"
                    >
                      Submit
                    </Button>
                  </InputRightElement>
                  <Input
                    id="email"
                    type="email"
                    name="email"
                    pl="20px"
                    focusBorderColor="teal.300"
                    borderRadius="9999px"
                    minW="288px"
                    fontSize="16px"
                    placeholder="Your Email"
                    borderColor="rgba(255, 255, 255, 0.36)"
                    color="#fff"
                    _placeholder={{ opacity: 1, color: "#CEE0DC !important" }}
                    _hover={{ border: "1px solid #AAB2B0" }}
                    width="100%"
                    h="48px"
                  />
                </InputGroup>
                {state.succeeded && (
                  <Text
                    textAlign="start"
                    fontSize="14px"
                    className="medium-text"
                    color="#fff"
                    fontStyle="italic"
                  >
                    Thank you, we will contact you shortly
                  </Text>
                )}
              </VStack>
            </HStack>
          </Stack>
        </form>
      </Stack>

      <Stack bg="#113F42" px={{ base: 4, "2xl": 0 }} py={{ base: 8, md: 16 }}>
        <Stack maxW="1280px" mx="auto" gap={0}>
          <HStack
            gap={0}
            w="100%"
            justifyContent="flex-start"
            alignItems="flex-start"
            flexDir={{ base: "column", md: "row" }}
          >
            <VStack
              gap={5}
              justifyContent="flex-start"
              alignItems="flex-start"
              mr={5}
            >
              <a href="/">
                <VellisLogoIcon w="209px" h="48px" color="#fff" />
              </a>
            </VStack>

            <HStack
              gap={0}
              w="100%"
              alignItems="flex-start"
              flexDirection={{ base: "column-reverse", md: "row" }}
            >
              <HStack
                gap={2}
                w="100%"
                mx="auto"
                alignItems="flex-start"
                maxW="800px"
                justifyContent={{
                  base: "space-between",
                  sm: "flex-start",
                  lg: "xl",
                }}
                wrap="wrap"
                spacing={0}
              >
                <VStack
                  gap={3}
                  alignItems="flex-start"
                  w={["134px", "134px", "136px", "160px", "180px"]}
                >
                  <a href="/financial-services">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="#fff"
                      mb={1}
                      className="medium-text"
                      fontSize="16px"
                    >
                      Financial Services
                    </Text>
                  </a>

                  <a href="/financial-services/multi-currency-accounts">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Multi-Currency Accounts
                    </Text>
                  </a>
                  <a href="/financial-services/business-payments">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Payments
                    </Text>
                  </a>
                  <a href="/financial-services/foreign-exchange">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Foreign Exchange
                    </Text>
                  </a>
                  <a href="/financial-services/payment-processing">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Payment Processing
                    </Text>
                  </a>
                </VStack>

                <VStack
                  gap={3}
                  alignItems="flex-start"
                  w={["134px", "134px", "136px", "160px", "147px"]}
                >
                  <a href="/solutions">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="#fff"
                      mb={1}
                      className="medium-text"
                      fontSize="16px"
                    >
                      Solutions
                    </Text>
                  </a>

                  {solutionsLinks.map(({ title, link }) => (
                    <a key={link} href={link}>
                      <Text
                        _hover={{ textDecoration: "underline" }}
                        color="rgba(255, 255, 255, 0.80)"
                        className="regular-text"
                        fontSize="14px"
                      >
                        {title}
                      </Text>
                    </a>
                  ))}
                </VStack>

                <VStack
                  w={["134px", "134px", "136px", "160px", "147px"]}
                  alignItems="flex-start"
                  gap={3}
                >
                  <Text
                    color="#fff"
                    mb={1}
                    className="medium-text"
                    fontSize="16px"
                  >
                    Get Started
                  </Text>
                  <a href="/how-it-works">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      How it Works
                    </Text>
                  </a>
                  <a href="/plans">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Plans
                    </Text>
                  </a>
                  <a href="/faq">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      FAQs
                    </Text>
                  </a>
                  <a href="">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Sign-up
                    </Text>
                  </a>
                </VStack>

                <VStack
                  alignItems="flex-start"
                  gap={3}
                  w={["134px", "134px", "136px", "160px", "147px"]}
                >
                  <Text
                    color="#fff"
                    mb={1}
                    className="medium-text"
                    fontSize="16px"
                  >
                    Resources
                  </Text>
                  <a href="/help-centre">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Help Centre
                    </Text>
                  </a>
                  <a href="/contact-support">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Contact Support
                    </Text>
                  </a>
                  <a href="/security">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Security
                    </Text>
                  </a>
                  <a href="/supported-currencies">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Supported Currencies
                    </Text>
                  </a>
                  <a href="/blog">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Blog
                    </Text>
                  </a>
                </VStack>

                <VStack
                  alignItems="flex-start"
                  gap={3}
                  w={["134px", "134px", "136px", "160px", "147px"]}
                >
                  <a href="/about-us">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="#fff"
                      mb={1}
                      className="medium-text"
                      fontSize="16px"
                    >
                      About Us
                    </Text>
                  </a>
                  {/* <Text
                  color="rgba(255, 255, 255, 0.80)"
                  className="regular-text"
                  fontSize="14px"
                >
                  Partners
                </Text> */}
                  <a href="/contact-us">
                    <Text
                      _hover={{ textDecoration: "underline" }}
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Contact Us
                    </Text>
                  </a>

                  <a href="/lets-talk-about-finance">
                    <Text
                      color="rgba(255, 255, 255, 0.80)"
                      className="regular-text"
                      fontSize="14px"
                    >
                      Let’s Talk About Finance
                    </Text>
                  </a>
                </VStack>
              </HStack>
              <HStack
                mb={{ base: 5, md: 0 }}
                ml={{ base: 0, lg: 5 }}
                py={{ base: 5, md: 0 }}
                gap={0}
              >
                <CanadaFlagIcon mr={4} w="36px" height="36px" />
                {/* <EUFlag w="36px" height="36px" /> */}
              </HStack>
            </HStack>
          </HStack>

          <Stack
            pb={5}
            justifyContent="space-between"
            flexDir={{ base: "column", md: "row" }}
          >
            {/* <HStack justifyContent="flex-end">
            <Image
              width={{ base: "140px", sm: "160px" }}
              height="48px"
              src={appStore}
              alt="Get it on Google Play"
              loading="lazy"
            />
            <Image
              width={{ base: "140px", sm: "160px" }}
              height="48px"
              src={googlePlay}
              alt="Get it on Google Play"
              loading="lazy"
            />
          </HStack> */}
          </Stack>
          <Stack
            gap={{ base: 3, sm: 6 }}
            justifyContent={{ base: "center", md: "flex-start" }}
            mx={{ base: "auto", sm: "center", lg: "flex-start" }}
            display="flex"
            flexDir="row"
            w="100%"
            py={5}
          >
            {ICONS.map((icon): any => {
              return (
                <a
                  key={icon.id}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={icon.link}
                >
                  <Box
                    position="relative"
                    width="44px"
                    height="44px"
                    borderRadius="99px"
                    bg="rgba(17, 98, 102, 0.20)"
                    _hover={{ bg: "rgba(17, 98, 102)" }}
                  >
                    <Icon
                      top={2.5}
                      right={2.5}
                      position="absolute"
                      fill="white"
                      width="24px"
                      height="24px"
                      as={icon.icon}
                    />
                  </Box>
                </a>
              );
            })}
          </Stack>
          <Divider gap={0} borderColor="rgba(255, 255, 255, 0.48)" mb={5} />
          <HStack
            justifyContent={{ base: "flex-start", md: "space-between" }}
            alignItems="flex-start"
            flexDirection={{ base: "column", md: "row" }}
            gap={0}
          >
            <Text
              color="rgba(255, 255, 255, 0.80)"
              className="regular-text"
              fontSize="16px"
              pb={{ base: 5, md: 0 }}
            >
              © 2025 Vellis Inc.
            </Text>
            <HStack
              alignItems={{ base: "flex-start", lg: "center" }}
              flexDirection={{ base: "column", md: "row" }}
              gap={5}
              color="rgba(255, 255, 255, 0.80)"
              fontSize="14px"
              className="regular-text"
            >
              <a href="/terms-and-conditions">
                <Text _hover={{ textDecoration: "underline" }}>
                  Terms and Conditions
                </Text>
              </a>
              <a href="/terms-of-service">
                <Text _hover={{ textDecoration: "underline" }}>
                  Terms of Service
                </Text>
              </a>
              <a href="/privacy-policy">
                <Text _hover={{ textDecoration: "underline" }}>
                  Privacy Policy
                </Text>
              </a>
              <a href="/cookies-policy">
                <Text _hover={{ textDecoration: "underline" }}>
                  Cookies Policy
                </Text>
              </a>
              <a href="/acceptance-policy">
                <Text _hover={{ textDecoration: "underline" }}>
                  Acceptance Policy
                </Text>
              </a>
              <a href="/complaints-policy">
                <Text _hover={{ textDecoration: "underline" }}>
                  Complaints Policy
                </Text>
              </a>
            </HStack>
          </HStack>
          <Text
            mt={5}
            className="regular-text"
            fontSize="16px"
            color="rgba(255, 255, 255, 0.80)"
          >
            Vellis Inc. is authorized as a Money Services Business by FINTRAC
            (Financial Transactions and Reports Analysis Centre of Canada)
            number M24204235. Vellis Inc. is a company registered in Canada,
            number 1000610768, headquartered at 30 Eglinton Avenue West,
            Mississauga, Ontario L5R3E7, Canada.
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Footer;
